import { PROJECT_ENTITY_CATEGORIES } from "../ProjectViewPage/constants/project-entity-category.ts"
import { CONTRACT_DECISIONS } from "../ProjectViewPage/constants/contract-decision.ts"

export type ContractPrompt = "contract-decision" | "reverse-contract" | null

interface AssignmentState {
  category: number
  contract_decision: number
}

/**
 * Which question a project-type category change has to ask before it is saved.
 *
 * Becoming a Change Request asks the contract question — but only once, so an
 * assignment that already answered it is never asked again. Ceasing to be one
 * asks whether to undo the contract impact, and only when there is an impact
 * to undo.
 */
export function projectTypeContractPrompt(
  previous: AssignmentState,
  nextCategory: number
): ContractPrompt {
  if (previous.category === nextCategory) return null

  const wasChangeRequest =
    previous.category === PROJECT_ENTITY_CATEGORIES.CHANGE_REQUEST
  const becomesChangeRequest =
    nextCategory === PROJECT_ENTITY_CATEGORIES.CHANGE_REQUEST

  if (becomesChangeRequest) {
    return previous.contract_decision === CONTRACT_DECISIONS.NOT_ASKED
      ? "contract-decision"
      : null
  }

  if (wasChangeRequest) {
    return previous.contract_decision === CONTRACT_DECISIONS.INCLUDED
      ? "reverse-contract"
      : null
  }

  return null
}

/** A delete only asks about money when the type actually moved the contract. */
export function deleteNeedsContractPrompt(previous: AssignmentState): boolean {
  return previous.contract_decision === CONTRACT_DECISIONS.INCLUDED
}
